import React, { Component, Fragment } from "react"
import { createPortal } from "react-dom"
import { BlockContextConsumer } from "../ContextProviders"
import { ThemeProvider } from "emotion-theming"
import smallDarkTheme from "features/editor/ui/smallDarkTheme"
import CSSEditor from "features/editor/ui/CSSEditor"
import MenuSection from "features/editor/ui/MenuSection"
import ReactFilestack from "lazyComponents/ReactFilestack"
import {
    Input,
    Label,
    Button,
    ButtonGroup,
    Collapsible,
    Container,
    Divider,
    Section,
    Dropdown,
    ColorPicker,
} from "ui"

import {
    Field,
    getBlockStyle,
    SmallField,
    TinyLabel,
    FieldLabel,
    SmallInput,
    SmallDropdown,
    SmallButton,
    InvertedImg,
    cssStyled,
    PaddingMarginInput,
    DummyBlock,
    DummyPadding,
    DummyMargins,
    TinyInput,
    PaddingMeasuringIndicator,
    MarginMeasuringIndicator,
} from "../ui/Pane"

import alignVMiddle from "assets/images/icons/align-v-middle.svg"
import alignVTop from "assets/images/icons/align-v-top.svg"
import wrapText from "assets/images/icons/wrap-text.png"

class BlockStylesPortal extends Component {
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block && (
                        <ThemeProvider theme={smallDarkTheme}>
                            <div
                                className="RenderBlockTypeAttributes"
                                onClick={event => event.stopPropagation()}
                            >
                                <div className="RenderBlockTypeAttributes-content">
                                    <Collapsible
                                        container={MenuSection("Layout", { margin: "none" })}
                                        defaultOpen
                                    >
                                        <Container padding="none" margin="none">
                                            <FieldLabel
                                                style={{
                                                    marginLeft: 60,
                                                    marginTop: 0,
                                                    marginBottom: 0,
                                                }}
                                            >
                                                Min
                                            </FieldLabel>{" "}
                                            <FieldLabel />
                                            <FieldLabel
                                                style={{
                                                    marginLeft: 30,
                                                    marginTop: 0,
                                                    marginBottom: 0,
                                                }}
                                            >
                                                Max
                                            </FieldLabel>
                                        </Container>
                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Height</FieldLabel>
                                                <SmallInput context={context} field="minHeight" />
                                                <SmallInput context={context} field="height" />
                                                <SmallInput context={context} field="maxHeight" />
                                            </Field>
                                        </Container>
                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Width</FieldLabel>
                                                <SmallInput context={context} field="minWidth" />
                                                <SmallInput context={context} field="width" />
                                                <SmallInput context={context} field="maxWidth" />
                                            </Field>
                                        </Container>
                                        <Container
                                            padding="none"
                                            marginTop="small"
                                            marginBottom="small"
                                        >
                                            <PaddingMarginInput context={context} />
                                        </Container>
                                        <Divider />
                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Expand/ Contract</FieldLabel>
                                                <ButtonGroup margin="none">
                                                    <SmallButton
                                                        icon="expand-arrows-alt"
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "layout",
                                                                "spread"
                                                            )
                                                        }
                                                        active={
                                                            !getBlockStyle(context, "layout") ||
                                                            getBlockStyle(context, "layout") ===
                                                                "spread"
                                                        }
                                                    />
                                                    <SmallButton
                                                        icon="compress"
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "layout",
                                                                "tight"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(context, "layout") ===
                                                            "tight"
                                                        }
                                                    />
                                                </ButtonGroup>
                                            </Field>
                                        </Container>
                                    </Collapsible>
                                    <Collapsible container={MenuSection("Contents")} defaultOpen>
                                        <Container>
                                            <Field>
                                                <FieldLabel>Direction</FieldLabel>
                                                <ButtonGroup margin="none">
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "flexDirection",
                                                                "column"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "flexDirection"
                                                            ) === "column"
                                                        }
                                                        icon="arrows-v"
                                                    />
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "flexDirection",
                                                                "row"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "flexDirection"
                                                            ) === "row"
                                                        }
                                                        icon="arrows-h"
                                                    />
                                                </ButtonGroup>
                                            </Field>
                                            <Field>
                                                <FieldLabel>Wrap</FieldLabel>
                                                <ButtonGroup margin="none">
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "flexWrap",
                                                                getBlockStyle(
                                                                    context,
                                                                    "flexWrap"
                                                                ) !== "nowrap"
                                                                    ? "nowrap"
                                                                    : "wrap"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(context, "flexWrap") !==
                                                            "nowrap"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={wrapText} />
                                                    </SmallButton>
                                                </ButtonGroup>
                                            </Field>
                                        </Container>
                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Align contents</FieldLabel>
                                                <ButtonGroup margin="none">
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "verticalAlignment",
                                                                "flex-start"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "verticalAlignment"
                                                            ) === "flex-start"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={alignVTop} />
                                                    </SmallButton>
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "verticalAlignment",
                                                                "center"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "verticalAlignment"
                                                            ) === "center"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={alignVMiddle} />
                                                    </SmallButton>
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "verticalAlignment",
                                                                "flex-end"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "verticalAlignment"
                                                            ) === "flex-end"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={alignVTop} rotate={180} />
                                                    </SmallButton>
                                                </ButtonGroup>
                                            </Field>
                                        </Container>

                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel />
                                                <ButtonGroup margin="none">
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "horizontalAlignment",
                                                                "flex-start"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "horizontalAlignment"
                                                            ) === "flex-start"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={alignVTop} rotate={270} />
                                                    </SmallButton>
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "horizontalAlignment",
                                                                "center"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "horizontalAlignment"
                                                            ) === "center"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg
                                                            src={alignVMiddle}
                                                            rotate={90}
                                                        />
                                                    </SmallButton>
                                                    <SmallButton
                                                        onClick={() =>
                                                            context.actions.updateStyle(
                                                                context.block.id,
                                                                "horizontalAlignment",
                                                                "flex-end"
                                                            )
                                                        }
                                                        active={
                                                            getBlockStyle(
                                                                context,
                                                                "horizontalAlignment"
                                                            ) === "flex-end"
                                                        }
                                                        style={{ padding: "6px 1px" }}
                                                    >
                                                        <InvertedImg src={alignVTop} rotate={90} />
                                                    </SmallButton>
                                                </ButtonGroup>
                                            </Field>
                                        </Container>

                                        {/* <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Horizontal Spacing</FieldLabel>
                                                <Input
                                                    value={getBlockStyle(
                                                        context,
                                                        "horizontalSpacing"
                                                    )}
                                                    onChange={event =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "horizontalSpacing",
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                            </Field>
                                        </Container>
                                        <Container padding="none" marginBottom="small">
                                            <Field>
                                                <FieldLabel>Vertical Spacing</FieldLabel>
                                                <Input
                                                    value={getBlockStyle(
                                                        context,
                                                        "verticalSpacing"
                                                    )}
                                                    onChange={event =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "verticalSpacing",
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                            </Field>
                                        </Container> */}
                                    </Collapsible>
                                    <Collapsible container={MenuSection("Text")} defaultOpen>
                                        <Field>
                                            <FieldLabel>Align</FieldLabel>
                                            <ButtonGroup margin="none">
                                                <SmallButton
                                                    icon="align-left"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "text-align",
                                                            "left"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "text-align") ===
                                                        "left"
                                                    }
                                                />

                                                <SmallButton
                                                    icon="align-center"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "text-align",
                                                            "center"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "text-align") ===
                                                        "center"
                                                    }
                                                />

                                                <SmallButton
                                                    icon="align-right"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "text-align",
                                                            "right"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "text-align") ===
                                                        "right"
                                                    }
                                                />
                                                <SmallButton
                                                    icon="align-justify"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "text-align",
                                                            "justify"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "text-align") ===
                                                        "justify"
                                                    }
                                                />
                                            </ButtonGroup>
                                        </Field>
                                        <Field>
                                            <FieldLabel>Font</FieldLabel>
                                            <Input
                                                value={getBlockStyle(context, "fontFamily")}
                                                onChange={event =>
                                                    context.actions.updateStyle(
                                                        context.block.id,
                                                        "fontFamily",
                                                        event.target.value
                                                    )
                                                }
                                            />
                                        </Field>
                                        <Field>
                                            <FieldLabel>Size</FieldLabel>
                                            <SmallInput context={context} field="fontSize" />
                                        </Field>
                                        <Field>
                                            <FieldLabel>Color</FieldLabel>{" "}
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    position: "relative",
                                                }}
                                            >
                                                <ColorPicker
                                                    color={getBlockStyle(context, "color")}
                                                    onChange={color =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "color",
                                                            color
                                                        )
                                                    }
                                                />
                                            </div>
                                        </Field>

                                        <Field>
                                            <FieldLabel>Weight</FieldLabel>
                                            <ButtonGroup margin="none">
                                                <SmallButton
                                                    icon="font"
                                                    iconWeight="light"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "fontWeight",
                                                            "lighter"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "fontWeight") ===
                                                        "lighter"
                                                    }
                                                />

                                                <SmallButton
                                                    icon="font"
                                                    iconWeight="regular"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "fontWeight",
                                                            "normal"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "fontWeight") ===
                                                        "normal"
                                                    }
                                                />

                                                <SmallButton
                                                    icon="font"
                                                    iconWeight="heavy"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "fontWeight",
                                                            "bold"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "fontWeight") ===
                                                        "bold"
                                                    }
                                                />
                                            </ButtonGroup>
                                        </Field>
                                    </Collapsible>
                                    <Collapsible container={MenuSection("Background")} defaultOpen>
                                        <Field>
                                            <Label size="fontS">Image</Label>
                                            <Input
                                                value={unwrapUrl(
                                                    getBlockStyle(context, "backgroundImage")
                                                )}
                                                onChange={event =>
                                                    context.actions.updateStyle(
                                                        context.block.id,
                                                        "backgroundImage",
                                                        wrapUrl(event.target.value)
                                                    )
                                                }
                                            />
                                            <ReactFilestack
                                                apikey="Arfn2PRozQ26eRkdQy74Ez"
                                                options={{
                                                    fromSources: [
                                                        "local_file_system",
                                                        "url",
                                                        "webcam",
                                                        "imagesearch",
                                                        "facebook",
                                                        "instagram",
                                                        "googledrive",
                                                        "dropbox",
                                                    ],
                                                    accept: "image/*",
                                                    maxFiles: 1,
                                                    storeTo: {
                                                        location: "s3",
                                                    },
                                                }}
                                                render={({ onPick }) => (
                                                    <Button
                                                        color="clear"
                                                        padding="small"
                                                        onClick={onPick}
                                                    >
                                                        Upload
                                                    </Button>
                                                )}
                                                onSuccess={value =>
                                                    context.actions.updateStyle(
                                                        context.block.id,
                                                        "backgroundImage",
                                                        wrapUrl(value.filesUploaded[0].url)
                                                    )
                                                }
                                            />
                                        </Field>
                                        <Field>
                                            <FieldLabel>Color</FieldLabel>
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    position: "relative",
                                                }}
                                            >
                                                <ColorPicker
                                                    color={getBlockStyle(
                                                        context,
                                                        "backgroundColor"
                                                    )}
                                                    onChange={color =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "backgroundColor",
                                                            color
                                                        )
                                                    }
                                                />
                                            </div>
                                        </Field>
                                    </Collapsible>
                                    <Collapsible container={MenuSection("Borders")} defaultOpen>
                                        <Field>
                                            <Label size="fontS">Borders</Label>
                                            <Input
                                                value={getBlockStyle(context, "border")}
                                                onChange={event =>
                                                    context.actions.updateStyle(
                                                        context.block.id,
                                                        "border",
                                                        event.target.value
                                                    )
                                                }
                                            />
                                        </Field>{" "}
                                        <Field>
                                            <Label size="fontS">Radius</Label>
                                            <SmallInput context={context} field="borderRadius" />
                                        </Field>
                                        <Field>
                                            <FieldLabel>Shadows</FieldLabel>
                                            <ButtonGroup margin="none">
                                                <SmallButton
                                                    icon="times"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "boxShadow",
                                                            "none"
                                                        )
                                                    }
                                                    active={
                                                        !getBlockStyle(context, "boxShadow") ||
                                                        getBlockStyle(context, "boxShadow") ===
                                                            "none"
                                                    }
                                                />
                                                <SmallButton
                                                    icon="check"
                                                    onClick={() =>
                                                        context.actions.updateStyle(
                                                            context.block.id,
                                                            "boxShadow",
                                                            "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)"
                                                        )
                                                    }
                                                    active={
                                                        getBlockStyle(context, "boxShadow") &&
                                                        getBlockStyle(context, "boxShadow") !==
                                                            "none"
                                                    }
                                                />
                                            </ButtonGroup>
                                        </Field>
                                    </Collapsible>
                                    <Collapsible container={MenuSection("Custom CSS")}>
                                        <Field>
                                            <CSSEditor
                                                className={cssStyled}
                                                value={getBlockStyle(context, "extras")}
                                                onChange={value =>
                                                    context.actions.updateStyle(
                                                        context.block.id,
                                                        "extras",
                                                        value
                                                    )
                                                }
                                            />
                                        </Field>
                                    </Collapsible>
                                </div>
                            </div>
                        </ThemeProvider>
                    )
                }
            </BlockContextConsumer>
            // <BlockContextConsumer>
            //     {context => {
            //         const block = context.block
            //         const setStyle = (field, value) =>
            //             context.actions.updateStyle(block.id, field, value)
            //         return (
            //             <ThemeProvider theme={stackerDarkTheme}>
            //                 <div
            //                     className="RenderBlockTypeStyles"
            //                     onClick={event => event.stopPropagation()}
            //                 >
            //                     <div className="RenderBlockTypeStyles-content">
            //                         <Input onChange={value => setStyle("color", value)} />
            //                     </div>
            //                 </div>
            //             </ThemeProvider>
            //         )
            //     }}
            //     }
            // </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("styles"))
    }
}

BlockStylesPortal.propTypes = {}

export default BlockStylesPortal

const wrapUrl = url => (url ? `url('${url}')` : url)
const unwrapUrl = url => {
    if (!url) return url
    let re = /url\('(.*)'\)/
    let matches = re.exec(url)
    if (!matches) return ""
    return matches[1]
}



// WEBPACK FOOTER //
// ./src/features/editor/styles/BlockStylesPortal.js